import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);


export function processModifications(orig, modif) {
	if (!Immutable.isMap(modif)) {
		return modif;
	}
	orig = orig || EMPTY_MAP;
	if (orig !== modif) {
		modif = modif.set('mod$', true);
	}
	let modKeys = [];
	let modValues = [];
	modif.entrySeq().forEach(e => {
		const key = e[0];
		if (key.startsWith('mod$')) {
			return;
		}
		let value = e[1];
		if (Immutable.isMap(value)) {
			const origValue = orig.get(key) || EMPTY_MAP;
			if (value != origValue) {
				modKeys.push(key);
				modValues.push({key, value: processModifications(origValue, value)});
			}
		} else if (Immutable.isList(value)) {
			const origValue = orig.get(key) || EMPTY_LIST;
			if (value !== origValue) {
				modKeys.push(key);
				value = value.map((value, index) => {
					return processModifications(origValue.get(index), value);
				});
				modValues.push({
					key,
					value
				});
			}
		} else {
			if (value !== orig.get(key)) {
				modKeys.push(key);
			}
		}
	});
	modKeys.forEach(key => {
		modif = modif.set('mod$' + key, true);
	});
	modValues.forEach(entry => {
		//console.log('setting ', entry.key, ' = ', (Immutable.isMap(entry.value) ? entry.value.toJS() : entry.value));
		modif = modif.set(entry.key, entry.value);
	});
	return modif;
}

